import { unpaidInvoices, formatMoney, type UnpaidInvoice } from "@/mocks/managerWorkspace";

export default function UnpaidWidget() {
  const visibleInvoices = unpaidInvoices.slice(0, 6);

  return (
    <div className="bg-white rounded-lg border border-[#D5CA8A] overflow-hidden h-full flex flex-col">
      <div className="flex items-center justify-between px-3 py-2 bg-[#FEF3C7] border-b border-[#D5CA8A]">
        <div className="flex items-center gap-1.5">
          <i className="ri-file-list-3-line text-[12px] text-[#2D2D2D]"></i>
          <span className="text-[11px] font-semibold text-[#2D2D2D]">Счета без оплаты / долги</span>
        </div>
        <span className="text-[11px] font-bold text-[#2D2D2D]">{unpaidInvoices.length}</span>
      </div>
      <div className="flex-1 overflow-auto">
        <table className="w-full text-[10px]">
          <thead>
            <tr className="bg-[#FDF2B5]/50 text-[#666666]">
              <th className="text-left px-2 py-1 font-medium">Клиент</th>
              <th className="text-left px-2 py-1 font-medium">Документ</th>
              <th className="text-left px-2 py-1 font-medium">Сумма</th>
              <th className="text-left px-2 py-1 font-medium">Просрочка</th>
            </tr>
          </thead>
          <tbody>
            {visibleInvoices.map((inv: UnpaidInvoice, i: number) => (
              <tr key={i} className="border-b border-[#D5CA8A]/30 hover:bg-[#FDF2B5]/30 transition-colors">
                <td className="px-2 py-1.5 text-[#2D2D2D]">{inv.client}</td>
                <td className="px-2 py-1.5 text-[#666666]">{inv.document}</td>
                <td className="px-2 py-1.5 text-[#2D2D2D] font-medium">{formatMoney(inv.amount)}</td>
                <td className="px-2 py-1.5">
                  <span className={`px-1.5 py-0.5 rounded text-[9px] font-medium ${inv.days > 10 ? "bg-[#FEE2E2] text-[#DC2626]" : inv.days > 5 ? "bg-[#FEF3C7] text-[#D97706]" : "bg-[#D4EDDA] text-[#2D6A4F]"}`}>
                    {inv.days} дн
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="px-3 py-1.5 border-t border-[#D5CA8A]">
        <button className="text-[10px] text-[#2D2D2D] hover:bg-[#FDF2B5] px-2 py-0.5 rounded transition-colors cursor-pointer">
          Все долги
        </button>
      </div>
    </div>
  );
}